import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatFormField } from '@angular/material/form-field';
import { MatTooltip } from '@angular/material/tooltip';
import { ComponentDefinition } from '@formbird/types';
import { ChangedDocumentService } from 'formbird-services';
import { FormbirdInjectorService } from '@services/injector/formbird-injector.service';
import { ComponentSetupService } from '../../../../formbird-sc-shared/src/lib/component-setup.service';
import { AbstractComponent } from '../../../../formbird-sc-shared/src/lib/components/abstract.component';

interface ReferenceNoComponentDefinition extends ComponentDefinition {
  caption?: string;
  onClick?: string;
  style?: string;
  floatLabel?: string;
}

@Component({
  templateUrl: './reference-no.component.html',
  styleUrls: ['./reference-no.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReferenceNoComponent extends AbstractComponent<ReferenceNoComponentDefinition> implements OnInit {

  constructor(
    protected formbirdInjectorService: FormbirdInjectorService,
    protected componentSetupService: ComponentSetupService,
    protected changedDocumentService: ChangedDocumentService,
    protected cdr: ChangeDetectorRef
  ) {
    super(formbirdInjectorService, changedDocumentService, componentSetupService, cdr);
  }

  ngOnInit() {

    if ((typeof this.componentDefinition.floatLabel === 'undefined' || this.componentDefinition.floatLabel === null)) {
      this.componentDefinition = {
        ... this.componentDefinition,
        floatLabel: 'auto'
      }

      this.notifyComponentDefChanged();
    }

    super.ngOnInit();

    const compThis = this;
    const updateDocumentSub = this.broadcastService.on('document:updated').subscribe((docs) => {
      // console.log('log: sc-reference-no (document:updated):', compThis, docs);
      if(compThis.document.documentId === docs[0].documentId){
        compThis.document = docs[0];
        if(!compThis.formControl.value){
          compThis.formControl.patchValue(compThis.document[compThis.fieldName], {emitEvent: false, onlySelf: true});
          compThis.detectChanges();
        }
      }
    });
    this.subs.add(updateDocumentSub);

  }

  showToolTip(tooltip: MatTooltip, formFieldContainer: MatFormField, labelContainer: HTMLElement) {
    return (labelContainer.offsetWidth <= formFieldContainer._elementRef.nativeElement.scrollWidth);
  }

  toggleTooltip(tooltip: MatTooltip) {
    setTimeout(() => {
      tooltip.toggle();
    });
  }
}

